import firebase from "firebase/app";
import "firebase/firestore";
import { Hit } from "instantsearch.js/es/types";
import { tAlgoliaBrand } from "tmt_api/src/types/types.validator";
import { validate } from "../../util/types";
import { tReduxAction } from "../types";

export const fetchExclusiveBrands = (): tReduxAction => {
  return (dispatch) => {
    firebase
      .firestore()
      .collection("brands")
      .where("isExclusive", "==", true)
      .get()
      .then((queryResults) => {
        const aExclusiveBrands: Hit<tAlgoliaBrand>[] = [];
        if (queryResults.empty) return;
        queryResults.docs.forEach((myExclusiveBrands) => {
          const validatedBrand = validate("tBrand")(myExclusiveBrands.data());
          if (validatedBrand.pauseMode !== "pause") {
            aExclusiveBrands.push({
              objectID: validatedBrand.id,
              brandStory: validatedBrand.brandStory ?? "",
              name: validatedBrand.name,
              productsNames: validatedBrand.productsNames ?? [],
              productsKeywords: validatedBrand.productsKeywords ?? [],
              categories: {
                lvl0: validatedBrand.categories.lvl0,
                lvl1: validatedBrand.categories.lvl1,
              },
              brandEthos: validatedBrand.brandEthos,
              isExclusive: validatedBrand.isExclusive ?? false,
              openingMin: validatedBrand.openingMin,
              reorderMin: validatedBrand.reorderMin,
              "images.logoDownloadURL": validatedBrand.images.logoDownloadURL,
              "images.heroes": validatedBrand.images.heroes,
              __position: 0,
            });
          }
        });
        dispatch({ type: "EXCLUSIVE_BRANDS", data: aExclusiveBrands });
      })
      .catch(() => console.log("No Exclusive Brands where found"));
  };
};
// Array<{ downloadURL: string; isPrimary: boolean; storageRef?: string }>
